import React, { useEffect, useState } from 'react';
import { filter } from 'rxjs/operators';
import styled from 'styled-components';

import TouchAppIcon from '@material-ui/icons/TouchApp';

import ActionService from '../../store/actions.service';

export interface IGuidedContainerProps {}

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 7777;
  pointer-events: none;
`;
const InternalContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const StyledTouchIcon = styled(TouchAppIcon)`
  position: absolute;
  top: 30px;
  left: 30px;
  font-size: 40px !important;
  color: white;
  display: none;
  animation: action 300ms infinite alternate;
  @-webkit-keyframes action {
    0% {
      transform: translateY(0) rotateZ(180deg);
    }
    100% {
      transform: translateY(-10px) rotateZ(180deg);
    }
  }
  @keyframes action {
    0% {
      transform: translateY(0) rotateZ(180deg);
    }
    100% {
      transform: translateY(-10px) rotateZ(180deg);
    }
  }
`;

export default function GuidedContainer(props: IGuidedContainerProps) {
  const [position, setPosition] = useState<any>({
    display: 'none',
  });
  useEffect(() => {
    const subscription = ActionService.getActions()
      .pipe(filter((action: any) => action.type === 'SHOW_INDICATOR'))
      .subscribe((action: any) => {
        const { payload } = action;
        setPosition({
          x: payload.x,
          y: payload.y,
          display: 'block',
        });
        setTimeout(() => {
          setPosition({
            display: 'none',
            x: 0,
            y: 0,
          });
        }, 1900);
      });
    return () => {
      subscription.unsubscribe();
    };
  }, []);
  return (
    <Container>
      <InternalContainer>
        <StyledTouchIcon
          style={{
            left: `${position.x}px`,
            top: `${position.y}px`,
            display: position.display,
          }}
        />
      </InternalContainer>
    </Container>
  );
}
